import React, { useState, useContext } from "react";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Tooltip,
  Paper,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/styles";
import { FiSearch } from "react-icons/fi";
import { useSpring, animated } from "react-spring";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { APIContext } from "../../Context/APIContext";
import { UserContext } from "../../Context/UserContext";
import { LangContext } from "../../Context/Langcontext";
import { getUsageStat } from "../../API/Usage";

const useStyle = makeStyles((theme) => ({
  label: {
    fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 400,
  },
  textfield: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 200,
    "& .MuiInputBase-root": {
      borderRadius: 8,
    },
  },
  icon: {
    width: "auto",
    height: theme.spacing(6),
    borderRadius: 8,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
    marginRight: "2rem",
  },
  gridcenter: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  maintext: {
    fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 600,
  },
  secontext: {
    fontSize: "1rem",
    color: "#595A5A",
    fontWeight: 200,
  },
  select: {
    "& .MuiSelect-root": {
      padding: "0.75rem 1rem",
      textOverflow: "ellipsis",
    },

    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight: 32,
    },
    "& .MuiSelect-icon": {
      color: "#E16733",
      fontSize: "2.25rem",
      top: "calc(50% - 18px)",
    },
    "& .MuiOutlinedInput-root": { borderRadius: 8 },
  },
  text: {
    borderRadius: 8,
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "1rem",
      marginBottom: "0.5rem",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "2rem",
    },
  },
  btndis: {
    borderRadius: 8,
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#ebebeb",
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      marginTop: "1rem",
      marginBottom: "0.5rem",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "2rem",
    },
  },
  divider: { width: 2, height: theme.spacing(8) },
  filterbox: {
    width: "100%",
  },
  autocomplete: {
    marginTop: theme.spacing(4),
    "& .MuiOutlinedInput-input": {
      fontWeight: 200,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 1.6,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: 8,
    },
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*=MuiOutlinedInput-root]":
      {
        paddingRight: "unset",
      },
    "& div.MuiChip-root.MuiAutocomplete-tag.MuiChip-deletable": {
      fontWeight: 400,
    },
    "& span.MuiAutocomplete-tag": {
      fontWeight: 400,
    },
    "& .MuiAutocomplete-option[data-selected=true]": {
      fontWeight: 200,
    },
  },
  atc: {
    fontWeight: 200,
  },
  form: {
    width: "100%",
    height: "100%",
    minHeight: "inherit",
  },
  gridcon: {
    margin: 0,
    width: "auto",
    "& .MuiGrid-item": {
      padding: "1px 5px",
    },
  },
  gridconlast: {
    margin: 0,
    width: "auto",
    "& .MuiGrid-item": {
      padding: "1px 1px 1px 1px",
    },
  },
  paperin: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    height: "-webkit-fill-available",
  },
  paper: {
    width: "-webkit-fill-available",
    height: "8.8rem",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    maxHeight: "100%",
  },
  paperreport: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      height: "auto",
    },
    [theme.breakpoints.up("md")]: {
      height: "-webkit-fill-available",
    },
  },
  autopopup: {
    "& .MuiAutocomplete-popupIndicatorOpen": {
      transform: "rotate(0deg)",
    },
  },
}));

const Customselect = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(4),
    },
  },
}))(TextField);

const Overview = ({ role, choice, state, setstate, setSum, setloading }) => {
  const classes = useStyle();
  const apiContext = useContext(APIContext);
  const userContext = useContext(UserContext);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const [toggle, settoggle] = useState(true);
  const { x } = useSpring({
    from: { x: 0 },
    x: toggle ? 1 : 0,
    config: { duration: 1000 },
  });

  const listPublic = [
    {
      title: lang.ApiKey,
      amount: apiContext.data.length.toLocaleString(),
      image: require("../../images/graphic-icon/api_key.png"),
    },
    {
      title: lang.ApiRequest,
      amount: userContext.sum.sum_request.toLocaleString(),
      image: require("../../images/graphic-icon/api_request.png"),
    },
    {
      title: lang.TotalBalance,
      amount: userContext.sum.balance.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      image: require("../../images/graphic-icon/balance.png"),
    },
  ];

  const list = [
    {
      title: lang.Users,
      amount: userContext.data
        .filter((rs) => {
          return rs.role !== "admin" && rs.role !== "root";
        })
        .length.toLocaleString(),
      image: require("../../images/graphic-icon/all_user.png"),
    },
    {
      title: lang.ApiKey,
      amount: apiContext.data.length.toLocaleString(),
      image: require("../../images/graphic-icon/api_key.png"),
    },
    {
      title: lang.ApiRequest,
      amount: userContext.sum.sum_request.toLocaleString(),
      image: require("../../images/graphic-icon/api_request.png"),
    },
    {
      title: lang.TotalBalance,
      amount: userContext.sum.sum_net.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      image: require("../../images/graphic-icon/balance.png"),
    },
  ];

  const userlist = userContext.data
    .filter((rs) => {
      return rs.role !== "admin" && rs.role !== "root";
    })
    .map((rs) => {
      return {
        title: `${rs.first_name} ${rs.last_name}`,
        value: rs._id,
        id: rs._id,
      };
    });

  const month = [
    { title: lang.SelectMonth, disabled: true, value: "" },
    { title: lang.Allmonth, disabled: false, value: "allmonth" },
    { title: lang.January, disabled: false, value: "01" },
    { title: lang.February, disabled: false, value: "02" },
    { title: lang.March, disabled: false, value: "03" },
    { title: lang.April, disabled: false, value: "04" },
    { title: lang.May, disabled: false, value: "05" },
    { title: lang.June, disabled: false, value: "06" },
    { title: lang.July, disabled: false, value: "07" },
    { title: lang.August, disabled: false, value: "08" },
    { title: lang.September, disabled: false, value: "09" },
    { title: lang.October, disabled: false, value: "10" },
    { title: lang.November, disabled: false, value: "11" },
    { title: lang.December, disabled: false, value: "12" },
  ];

  const SearchReport = async (e) => {
    e.preventDefault();

    const dateTimeRef =
      state.month === "allmonth"
        ? `${moment(`${state.year}-01-01`).format("X")},${moment(
            `${state.year}-01-01`
          )
            .add(1, "year")
            .format("X")}`
        : `${moment(`${state.year}-${state.month}-01`).format("X")},${moment(
            `${state.year}-${state.month}-01`
          )
            .add(1, "month")
            .format("X")}`;

    const input = `/aggregate?datetime_ref=${dateTimeRef}&user_id=${
      state.name.id
    }&${
      state.key === "other" ? "" : `apikey_id=${state.key}&`
    }group=service_id,user_id,datetime_ref,apikey_id&sort=_id.datetime_ref:asc`;

    const get = await getUsageStat(input);
    if (get.status.code === 200) {
      if (state.filter) {
        settoggle(!toggle);
        setstate({ ...state, loading: true });
        setTimeout(() => {
          setstate({
            ...state,
            filter: false,
            name: "",
            key: "",
            month: "",
            year: "",
          });
        }, 1000);
      } else {
        settoggle(!toggle);
        setstate({ ...state, loading: true });
        setTimeout(() => {
          setstate({
            ...state,
            filter: true,
          });
        }, 2000);
      }
      setloading(true);
      setTimeout(() => {
        setloading(false);
        setSum(get.data);
      }, 1000);
    }
  };

  const getYears = () => {
    let obj = {};
    let currentYear = new Date().getFullYear();

    let years = [];
    while (currentYear >= 2020) {
      let cyear = currentYear--;
      obj.title = cyear;
      obj.value = cyear;
      years.push(obj);
      obj = {};
    }
    return years;
  };

  return (
    <form onSubmit={SearchReport} className={classes.form}>
      <Grid container spacing={2} className={classes.gridcon}>
        {role === "Administrator" && choice === 3 ? (
          <>
            <Paper
              className={classes.paper}
              style={{
                margin: "1px 5px",
                overflowX: "auto",
              }}
            >
              <div
                style={{ padding: "1rem", height: "-webkit-fill-available" }}
              >
                <div className={classes.paperreport}>
                  <Grid container>
                    <Grid
                      item
                      md={4}
                      sm={6}
                      xs={6}
                      className={classes.gridcenter}
                    >
                      <FormControl className={classes.filterbox}>
                        <InputLabel shrink className={classes.label}>
                          {lang.UserName}
                        </InputLabel>
                        <Autocomplete
                          id="multiple-user-list"
                          options={userlist}
                          disabled={state.filter}
                          onInputChange={(e, v) => {}}
                          getOptionLabel={(option) => option.title}
                          value={state.name}
                          onChange={(e, v) => {
                            setstate({ ...state, name: v });
                          }}
                          className={classes.autopopup}
                          classes={{ paper: classes.atc }}
                          popupIcon={<FiSearch />}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              fullWidth
                              required
                              className={classes.autocomplete}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      md={3}
                      sm={6}
                      xs={6}
                      className={classes.gridcenter}
                    >
                      <FormControl className={classes.filterbox}>
                        <InputLabel shrink className={classes.label}>
                          {lang.Key}
                        </InputLabel>
                        <Customselect
                          select
                          id="custom-input"
                          variant="outlined"
                          disabled={state.filter}
                          required
                          SelectProps={{
                            native: true,
                          }}
                          value={state.key}
                          onChange={(e) => {
                            setstate({ ...state, key: e.target.value });
                          }}
                          className={classes.select}
                          inputProps={{
                            className: classes.textfield,
                          }}
                        >
                          <option key={lang.Selectkeyname} value={""} disabled>
                            {lang.Selectkeyname}
                          </option>
                          {state.name !== null
                            ? apiContext.data
                                .filter((rs) => {
                                  return rs.user_id === state.name.id;
                                })
                                .map((option) => {
                                  return (
                                    <option key={option._id} value={option._id}>
                                      {`${
                                        option.app_name
                                      }-${option.api_key.substring(0, 4)}`}
                                    </option>
                                  );
                                })
                            : null}
                          {state.name !== null ? (
                            <option value={"other"}>ทั้งหมด</option>
                          ) : null}
                        </Customselect>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      md={2}
                      sm={6}
                      xs={6}
                      className={classes.gridcenter}
                    >
                      <FormControl className={classes.filterbox}>
                        <InputLabel shrink className={classes.label}>
                          {lang.Month}
                        </InputLabel>
                        <Customselect
                          select
                          required
                          disabled={state.filter}
                          id="custom-input"
                          variant="outlined"
                          SelectProps={{
                            native: true,
                          }}
                          value={state.month}
                          className={classes.select}
                          onChange={(e) => {
                            setstate({ ...state, month: e.target.value });
                          }}
                          inputProps={{
                            className: classes.textfield,
                          }}
                        >
                          {month.map((option) => (
                            <option
                              key={option.title}
                              value={option.value}
                              disabled={option.disabled}
                            >
                              {option.title}
                            </option>
                          ))}
                        </Customselect>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      md={2}
                      sm={6}
                      xs={6}
                      className={classes.gridcenter}
                    >
                      <FormControl className={classes.filterbox}>
                        <InputLabel shrink className={classes.label}>
                          {lang.Year}
                        </InputLabel>
                        <Customselect
                          select
                          required
                          id="custom-input"
                          variant="outlined"
                          disabled={state.filter}
                          SelectProps={{
                            native: true,
                          }}
                          value={state.year}
                          className={classes.select}
                          onChange={(e) => {
                            setstate({ ...state, year: e.target.value });
                          }}
                          inputProps={{
                            className: classes.textfield,
                          }}
                        >
                          <option key={lang.Selectyear} value={""} disabled>
                            {lang.Selectyear}
                          </option>
                          {getYears().map((option) => (
                            <option key={option.title} value={option.value}>
                              {option.title}
                            </option>
                          ))}
                        </Customselect>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      md={1}
                      sm={12}
                      xs={12}
                      className={classes.gridcenter}
                    >
                      <Button
                        className={
                          state.loading ? classes.btndis : classes.btnstyle
                        }
                        disabled={state.loading}
                        type="submit"
                      >
                        {state.filter ? (
                          <animated.div
                            style={{
                              transform: x
                                .interpolate({
                                  range: [
                                    0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1,
                                  ],
                                  output: [
                                    1, 0.97, 0.9, 1.1, 0.9, 1.1, 1.03, 1,
                                  ],
                                })
                                .interpolate((x) => `scale(${x})`),
                            }}
                          >
                            {lang.Clear}
                          </animated.div>
                        ) : (
                          <animated.div
                            style={{
                              opacity: x.interpolate({
                                range: [0, 1],
                                output: [0.1, 1],
                              }),
                              transform: x
                                .interpolate({
                                  range: [
                                    0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1,
                                  ],
                                  output: [
                                    1, 0.97, 0.9, 1.1, 0.9, 1.1, 1.03, 1,
                                  ],
                                })
                                .interpolate((x) => `scale(${x})`),
                            }}
                          >
                            {lang.Filter}
                          </animated.div>
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Paper>
          </>
        ) : role === "Administrator" ? (
          list.map((res, index) => {
            return (
              <Grid
                key={res.title}
                item
                md={3}
                sm={3}
                xs={3}
                className={classes.gridcenter}
              >
                <Tooltip title={`จำนวน${res.title}`} placement="top">
                  <Paper className={classes.paper}>
                    <div className={classes.paperin}>
                      <img
                        alt="apikey"
                        src={res.image}
                        className={classes.icon}
                      />
                      <div style={{ textAlign: "center" }}>
                        <Typography className={classes.maintext}>
                          {res.amount.toLocaleString()}
                        </Typography>
                        <Typography className={classes.secontext}>
                          {res.title}
                        </Typography>
                      </div>
                    </div>
                  </Paper>
                </Tooltip>

                {/* {index !== list.length - 1 ? (
                  <Divider orientation="vertical" className={classes.divider} />
                ) : null} */}
              </Grid>
            );
          })
        ) : localStorage.getItem("role") === "public" ? (
          <>
            {listPublic.map((res, index) => {
              return (
                <Grid
                  key={res.title}
                  item
                  md={4}
                  sm={4}
                  xs={4}
                  className={classes.gridcenter}
                >
                  <Tooltip title={`จำนวน${res.title}`} placement="top">
                    <Paper className={classes.paper}>
                      <div className={classes.paperin}>
                        <img
                          alt="apikey"
                          src={res.image}
                          className={classes.icon}
                        />
                        <div style={{ textAlign: "center" }}>
                          <Typography className={classes.maintext}>
                            {res.amount.toLocaleString()}
                          </Typography>
                          <Typography className={classes.secontext}>
                            {res.title}
                          </Typography>
                        </div>
                      </div>
                    </Paper>
                  </Tooltip>
                </Grid>
              );
            })}
          </>
        ) : (
          <>
            <Grid item xs={4} className={classes.gridcenter}>
              <Tooltip title={`จำนวน${lang.ApiKey}`} placement="top">
                <Paper className={classes.paper}>
                  <div className={classes.paperin}>
                    <img
                      alt="apikey"
                      src={require("../../images/graphic-icon/api_key.png")}
                      className={classes.icon}
                      style={{ marginRight: "2rem" }}
                    />
                    <div style={{ textAlign: "center" }}>
                      <Typography className={classes.maintext}>
                        {apiContext.data.length.toLocaleString()}
                      </Typography>
                      <Typography className={classes.secontext}>
                        {lang.ApiKey}
                      </Typography>
                    </div>
                  </div>
                </Paper>
              </Tooltip>
            </Grid>
            <Grid item xs={4} className={classes.gridcenter}>
              <Tooltip title={`จำนวน${lang.ApiRequest}`} placement="top">
                <Paper className={classes.paper}>
                  <div className={classes.paperin}>
                    <img
                      alt="apikey"
                      src={require("../../images/graphic-icon/api_request.png")}
                      className={classes.icon}
                      style={{ marginRight: "2rem" }}
                    />
                    <div style={{ textAlign: "center" }}>
                      <Typography className={classes.maintext}>
                        {userContext.sum.sum_request.toLocaleString()}
                      </Typography>
                      <Typography className={classes.secontext}>
                        {lang.ApiRequest}
                      </Typography>
                    </div>
                  </div>
                </Paper>
              </Tooltip>
            </Grid>

            <Grid item xs={4} className={classes.gridcenter}>
              <Tooltip title={`จำนวน${lang.TotalBalance}`} placement="top">
                <Paper className={classes.paper}>
                  <div className={classes.paperin}>
                    <img
                      alt="apikey"
                      src={require("../../images/graphic-icon/balance.png")}
                      className={classes.icon}
                      style={{ marginRight: "2rem" }}
                    />
                    <div style={{ textAlign: "center" }}>
                      <Typography className={classes.maintext}>
                        {userContext.sum.balance
                          .toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                          .toLocaleString()}
                      </Typography>
                      <Typography className={classes.secontext}>
                        {lang.TotalBalance}
                      </Typography>
                    </div>
                  </div>
                </Paper>
              </Tooltip>
            </Grid>
          </>
        )}
      </Grid>
    </form>
  );
};

export default Overview;
